import { Alert, Button } from "antd-v5";
import message from "components/CustomMessage";
import React from "react";

interface SetupInstructionsProps {
  serviceAccountClientId: string | undefined;
}

export function GoogleWorkspaceSetupInstructions({
  serviceAccountClientId,
}: SetupInstructionsProps) {
  return (
    <Alert
      type="warning"
      className="m-b-xs"
      message="Setup Instructions"
      description={
        <ol className="m-b-0 p-l-sm">
          <li>
            Open{" "}
            <a
              href="https://admin.google.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google Admin Console
            </a>{" "}
            and go to{" "}
            <strong>
              Security &gt; Access and data control &gt; API controls &gt;
              Domain-wide delegation
            </strong>
            .
          </li>
          <li>
            Click <strong>Add new</strong> and enter the Client ID:{" "}
            {serviceAccountClientId ? (
              <>
                <code>{serviceAccountClientId}</code>{" "}
                <Button
                  size="small"
                  onClick={() => {
                    navigator.clipboard.writeText(serviceAccountClientId);
                    message.success("Client ID copied");
                  }}
                >
                  Copy
                </Button>
              </>
            ) : (
              <em>loading…</em>
            )}
          </li>
          <li>
            Select the products below — the{" "}
            <strong>Required OAuth Scopes</strong> will update automatically.
          </li>
          <li>
            Paste the required scopes into the OAuth scopes field in the Admin
            Console and click <strong>Authorize</strong>.
          </li>
          <li>
            Return here and enter the email of a{" "}
            <strong>Google Workspace Super Admin</strong> in the field below
            (used for service account impersonation).
          </li>
        </ol>
      }
    />
  );
}

interface OAuthScopesProps {
  requiredScopes: string[];
}

export function GoogleWorkspaceOAuthScopes({
  requiredScopes,
}: OAuthScopesProps) {
  if (requiredScopes.length === 0) return null;

  return (
    <Alert
      type="info"
      className="m-t-xs m-b-xs"
      message={
        <span>
          Required OAuth Scopes{" "}
          <Button
            size="small"
            onClick={() => {
              navigator.clipboard.writeText(requiredScopes.join(","));
              message.success("Scopes copied");
            }}
          >
            Copy all
          </Button>
        </span>
      }
      description={
        <ul className="m-b-0 p-l-sm">
          {requiredScopes.map((scope) => (
            <li key={scope}>
              <code>{scope}</code>
            </li>
          ))}
        </ul>
      }
    />
  );
}
